import api from './api'

const clubService = {
  async getMyClub() {
    const response = await api.get('/club/me')
    return response.data
  },
  async updateClub(clubData) {
    const response = await api.patch('/club/me', clubData)
    return response.data
  },
  async updateLogo(logoUrl) {
    return this.updateClub({ logo_url: logoUrl })
  },
  async updateColors(primaryColor, secondaryColor) {
    return this.updateClub({ primary_color: primaryColor, secondary_color: secondaryColor })
  },

  // ── Carte joueur V2 (pcv005) ───────────────────────────────────────
  // Upload fichier multipart -> S3 PRIVE + cleanup fond noir cote backend.
  // FIX 422 : l'instance axios (api.js) impose un defaut global
  // 'Content-Type: application/json'. Sans override, le FormData part en
  // application/json (sans boundary multipart) -> FastAPI ne trouve pas
  // le champ `file` -> 422. On met Content-Type a undefined pour CETTE
  // requete : axios v1 retire alors le defaut et son serialiseur FormData
  // repose lui-meme 'multipart/form-data; boundary=...'.
  async uploadLogo(file) {
    const formData = new FormData()
    formData.append('file', file)
    const response = await api.post('/club/logo', formData, {
      headers: { 'Content-Type': undefined },
    })
    return response.data // { logo_url: string }
  },

  // Le bucket logo est prive (BPA) : pas d'<img src=logo_url> direct.
  // logo-preview renvoie une presigned GET 1h (ou l'URL externe legacy
  // telle quelle), ou null si aucun logo.
  async getLogoPreview() {
    const response = await api.get('/club/logo-preview')
    return response.data // { preview_url: string | null }
  },

  async updateCompetitionLevel(level) {
    return this.updateClub({ competition_level: level })
  },
}

export default clubService
